import { Component, Input, OnChanges, OnInit, SimpleChanges, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'ltts-my-request-attendance',
  templateUrl: './my-request-attendance.component.html',
  styleUrls: ['./my-request-attendance.component.scss']
})
export class MyRequestAttendanceComponent implements OnInit {
  myRequestData:any;
  @Input()
  set myRequest(value: any) {
    if (value) {
      this.myRequestData=value
    }
  }
  @Input() expanded: boolean = false;
  @Input() hasActiveISMS: any;
  @Input() hasActiveDataPrivacy: any;
  @Input() completedCount: number = 0;
  @Input() notifications: any[] = [];
  @Input() hasActiveQuiz: boolean = false;
  @Input() showQuizNotify: boolean = true;
  @Input() hasActiveTownhall: boolean = false;
  @Input() showTownhallNotify: boolean = true;
  @Input() talentAIData: boolean | undefined 

  // Notify section outputs
  @Output() collapseSidenavEvent = new EventEmitter<void>();
  @Output() navigateToUrlEvent = new EventEmitter<string>();
  @Output() goToEventEvent = new EventEmitter<number>();

  ngOnInit(): void{
  }
   // Notify section event handlers
  cancelClicked() {
    this.collapseSidenavEvent.emit();
  }

  navigateToUrl(url: string) {
    this.navigateToUrlEvent.emit(url);
  }

}
